import deepClone from "../../foundation/js/deepClone"
import createFilterConfiguration from './productSearch/createFilterConfiguration.action'
import insertProductData from './productSearch/insertProductData.action'
import getFilterDisplaynames from './productSearch/getFilterDisplayNames.action'
import setSortingOptions from './productSearch/setSortingOptions.action'
import performInitialSearch from './productSearch/performInitialSearch.action'

export default {
    namespaced: true,
    state: {
        default_take: 20,
        take: 0,
        skip: 0,
        displayed_count: 0,
        quick_search_displayed_count: 0,
        search_result_max_count: 0,
        quick_search_result_max_count: 0,
        search_spinner_visible: true,
        quick_search_spinner_visible: true,
        search_string: '',
        filterColumnVisible: true,
        products: [],
        quick_search_results: [],
        sorting_options: [],
        filters: [],
        filter_displaynames: {},
        page_data: {},
        latest_request_id: 0
    },
    mutations: {
        setPageData(state, payload) {
            state.page_data = payload
        },
        set_filters(state, filters) {
            state.filters = filters
        },
        toggleFilterColumnVisilibity(state, visible) {
            state.filterColumnVisible = visible
        },
        set_sorting_options(state, options) {
            state.sorting_options = options.map(option => {
                option.selected = !!option.selected
                return option
            })
        },
        set_new_sorting(state, newSorting) {
            if (!state.sorting_options.find(option => option.value === newSorting.value)) return

            state.sorting_options = state.sorting_options.map(option => {
                option.selected = !!(option.value === newSorting.value)
                return option
            })
        },
        set_filter_displaynames(state, data) {
            state.filter_displaynames = data
        },
        set_products(state, products) {
            state.products = products
        },
        update_search_spinner(state, status) {
            state.search_spinner_visible = status
        },
        update_quick_search_spinner(state, status) {
            state.quick_search_spinner_visible = status
        },
        set_search_result_max_count(state, count) {
            state.search_result_max_count = count
        },
        set_quick_search_result_max_count(state, count) {
            state.quick_search_result_max_count = count
        },
        set_displayed_count(state, config) {
            state.displayed_count = config.appendResults ? (state.displayed_count + config.displayedCount) : config.displayedCount
        },
        set_quick_search_displayed_count(state, count) {
            state.quick_search_displayed_count = count
        },
        increase_skip(state) {
            state.skip = state.displayed_count
        },
        set_skip(state, value) {
            state.skip = value
        },
        set_search_string(state, string) {
            state.search_string = string
        },
        set_take(state, value) {
            state.take = value
        },
        reset_take_to_default(state) {
            state.take = state.default_take
        },
        set_quick_search_results(state, products) {
            state.quick_search_results = products
        },
        increment_latest_request_id(state) {
            state.latest_request_id++
        }
    },
    actions: {
        loadMore(context) {
            context.commit('increase_skip')
            context.dispatch('performSearch', { appendResults: true })
        },
        sortProducts(context, sortOption) {
            context.commit('set_new_sorting', sortOption)
            context.commit('set_skip', 0)
            context.dispatch('performSearch')
        },
        filterProducts(context, filter) {
            const filtersCopy = deepClone(context.state.filters)
            context.commit('set_skip', 0)
            context.commit("set_filters", filtersCopy.map(group => {
                if (group.name === filter.group) {
                    group.facets.map(facet => {
                        if (facet.name === filter.facet) {
                            facet.selected = facet.selected ? false : new Date().getTime()
                        }
                        return facet
                    })
                }
                return group
            }))

            context.dispatch('performSearch')
        },
        resetSelectedFilters(context){
            const filtersCopy = deepClone(context.state.filters)
            context.commit('set_skip', 0)
            context.commit("set_filters", filtersCopy.map(group => {
                group.facets.map(facet => {
                    facet.selected = false
                    return facet
                })
                return group
            }))
        },
        performQuickSearch(context, config) {
            context.commit('set_search_string', config.searchString)

            const searchString = context.getters.urlQuickSearchString
            const url = process.env.SEARCH_PRODUCTS + searchString

            context.commit('update_quick_search_spinner', true)

            fetch(url)
                .then(res => {
                    if (res.ok) {
                        return res.json()
                    }
                })
                .then(json => {

                    context.dispatch('insertProductData', { json: json.productResults, mutation: 'set_quick_search_results' })
                    context.commit('set_quick_search_result_max_count', json.totalCount)
                    context.commit('set_quick_search_displayed_count', json.displayedCount)


                })
                .catch(err => console.error("Product search failed :", err))
        },
        performStringSearch(context, config) {
            context.dispatch('resetSelectedFilters')

            if (config !== undefined)
                context.commit('set_search_string', config.searchString)

            context.dispatch('performSearch')

        },
        performExcelSearch(context, config) {
            context.commit('set_search_string', config.searchString)
            context.dispatch('performSearch', { searchAPI: process.env.SEARCH_PRODUCTS_SKUS })
        },
        performSearch(context, config) {
            const appendResults = !!config && config.appendResults
            if (!appendResults) {
                context.commit('set_skip', 0)
            }
            context.commit('increment_latest_request_id')
            let latest_request_id = context.state.latest_request_id

            const baseUrl = (config && config.searchAPI) ? config.searchAPI : process.env.SEARCH_PRODUCTS;
            const searchString = (config && config.searchString) ? config.searchString : context.getters.urlSearchString;
            const filterParameters = context.rootState.main.page_filters ? ('&' + context.rootState.main.page_filters) : '';

            const rawUrl = `${baseUrl}${searchString}${filterParameters}&requestId=${latest_request_id}`;

            const absoluteUrl = rawUrl.startsWith('http') ? rawUrl : `${window.location.origin}${rawUrl}`;
            const u = new URL(absoluteUrl);

            const keysToDelete = [];
            for (const [key, value] of u.searchParams.entries()) {
                if (value === null || value === undefined || value === 'undefined' || value === 'null') {
                    keysToDelete.push(key);
                }
            }
            for (const k of keysToDelete) u.searchParams.delete(k);

            u.searchParams.set('requestId', String(latest_request_id));
            if (context.rootState.main.lang.isoCode) {
                u.searchParams.set('isocode', context.rootState.main.lang.isoCode)
            }

            const url = u.pathname + u.search;

            context.commit('update_search_spinner', true)
            fetch(url)
                .then(res => {
                    if (res.ok) {
                        return res.json()
                    }
                    else {
                        throw new Error(`HTTP error! status: ${res.status}`)
                    }
                })
                .then(json => {
                    if (json.requestId && json.requestId !== context.state.latest_request_id) {
                        return
                    }

                    var facetResults = json.facetResults;
                    if (json.facetResults && context.rootState.main.page_filters) {
                        var pageFilters = []
                        context.rootState.main.page_filters.split("&").forEach(y => pageFilters.push(y.substring(0, y.indexOf('['))));
                        var pageFiltersJoin = pageFilters.join(",")
                        for (const facetResult in json.facetResults) {
                            if (pageFiltersJoin.indexOf(facetResult) > -1)
                                delete facetResults[facetResult]
                        }
                    }
                    context.commit('set_search_result_max_count', json.totalCount)
                    context.commit('set_displayed_count', { displayedCount: json.displayedCount, appendResults })
                    context.dispatch('createFilterConfiguration', facetResults)
                    context.dispatch('insertProductData', { json: json.productResults, mutation: 'set_products', appendResults })


                })
                .catch(err => console.error("Product search failed :", err))

        },
        updateSearchData(context, json) {
            context.dispatch('createFilterConfiguration', json.facetResults)
            context.dispatch('insertProductData', json.productResults)
            context.commit('set_search_result_max_count', json.totalCount)
            context.commit('set_displayed_count', { displayedCount: json.displayedCount })
        },
        performInitialSearch,
        createFilterConfiguration,
        getFilterDisplaynames,
        insertProductData,
        setSortingOptions
    },
    getters: {
        nextTakeValue(state) {
            const take = state.take || state.default_take
            const remaining = state.search_result_max_count - state.displayed_count
            return remaining > take || remaining === 0 ? take : remaining
        },
        moreResultsAvailable(state) {
            return !!(state.search_result_max_count > state.displayed_count)
        },
        listSelectedFacets(state) {

            const filtersWithFacetsSelected = state.filters.filter(filter => {
                return filter.facets.find(facet => facet.selected)
            })

            const listOfSelectedFacets = filtersWithFacetsSelected.reduce((list, filter, index) => {
                const selectedFacets = filter.facets.filter(facet => facet.selected)
                const returnList = selectedFacets.map(selectedFacet => {
                    return {
                        value: (selectedFacet.name === 'toggle') || selectedFacet.name,
                        name: filter.name
                    }
                })
                return list.concat(returnList)
            }, [])

            return listOfSelectedFacets
        },
        urlEncoded(state, getters) {
            const selectedFacets = getters.listSelectedFacets

            const activeSortingAsString = state.sorting_options
                .filter(option => option.selected)
                .reduce((string, sorting) => {
                    return `${string}sortBy=${encodeURIComponent(sorting.value)}&`
                }, '?')

            return selectedFacets.reduce((string, facet, index) => {
                return `${string}${encodeURIComponent(facet.name)}=${encodeURIComponent(facet.value)}&`
            }, activeSortingAsString)
        },
        urlSearchString(state, getters, rootState) {
            const urlEncoded = getters.urlEncoded
            const searchString = state.search_string ? `q=${encodeURIComponent(state.search_string)}&` : ''
            const takeForRequest = state.skip === 0 ? (state.take || state.default_take) : getters.nextTakeValue

            return `${urlEncoded}${searchString}take=${takeForRequest}&skip=${state.skip}&isocode=${rootState.main.lang.isoCode}&categoryGuid=${state.page_data.categoryGuid}&categoryPimId=${state.page_data.categoryPimId}`
        },
        urlQuickSearchString(state, getters, rootState) {
            const urlEncoded = getters.urlEncoded
            const searchString = state.search_string ? `q=${encodeURIComponent(state.search_string)}&` : ''

            return `${urlEncoded}${searchString}take=4&skip=0&isocode=${rootState.main.lang.isoCode}`
        },
        browserUrlString(state, getters) {
            const urlEncoded = getters.urlEncoded
            const searchString = state.search_string ? `q=${encodeURIComponent(state.search_string)}&` : ''

            return `${urlEncoded}${searchString}take=${state.displayed_count ? state.displayed_count : getters.nextTakeValue}`
        },
        mainFacetsExcluded(state) {
            const filtersCopy = deepClone(state.filters)
            return filtersCopy.filter(group => group.name !== 'MainFilters')
        },
        mainFilterFacets(state) {
            const filtersCopy = deepClone(state.filters)
            return filtersCopy.find(group => group.name === 'MainFilters')

        },
        selectedFacetsOrdered(state) {
            const filtersCopy = deepClone(state.filters)
            let selectedFacets = []

            filtersCopy.forEach(group => {
                const groupFacets = group.facets.filter(facet => facet.selected)
                selectedFacets = selectedFacets.concat(groupFacets.map(facet => {
                    facet.group = group
                    return facet
                }))
                selectedFacets.sort((a, b) => {
                    if (a.selected < b.selected) return -1
                })
            })

            return selectedFacets
        },
        productsList(state, getters, rootState) {
            const msrp = rootState.ecom.show_msrp
            const products = deepClone(state.products)

            return products.map(product => {
                product.price = msrp ? product.retailPrice : product.price
                product.taxLabel = msrp ? product.retailPrice.taxLabel : product.price.taxLabel
                return product
            })
        }
    }
}
